import React, { useState, useCallback, useEffect } from 'react';
import './styles.scss';
import './radix-dropdown.scss';
import Cookies from 'js-cookie';
import logoWhite from './hp-white.svg';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { Button, Icons } from '@hyperping/design';
import RightArrow from '../../v3/Hero/right-arrow.svg';

import { graphql, useStaticQuery } from "gatsby"

const useInternalPaths = () => {
  const {
    pages: { nodes },
  } = useStaticQuery(graphql`
    {
      pages: allSitePage {
        nodes {
          path
        }
      }
    }
  `)

  return nodes.map(node => node.path)
}

const setCookies = () => {
  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(window.location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  const searchParams = new URLSearchParams(window.location.href.split('?')[1]);
  const ref = searchParams.get('ref');

  // Give the URL parameters variable names
  var utm_source = getParameterByName('utm_source');
  var utm_medium = getParameterByName('utm_medium');
  var utm_campaign = getParameterByName('utm_campaign');

  if (utm_source != "" && !Cookies.get("utm_source")) {
    Cookies.set('utm_source', utm_source, { expires: 365, domain: 'hyperping.io' });
  }
  if (utm_medium != "" && !Cookies.get("utm_medium")) {
    Cookies.set('utm_medium', utm_medium, { expires: 365, domain: 'hyperping.io' });
  }
  if (utm_campaign != "" && !Cookies.get("utm_campaign")) {
    Cookies.set('utm_campaign', utm_campaign, { expires: 365, domain: 'hyperping.io' });
  }
  const referrer = Cookies.get("referrer");
  if (!!document.referrer && !(!!referrer)) {
    Cookies.set('referrer', document.referrer, { expires: 365, domain: 'hyperping.io' });
  }
  if (ref != "" && !Cookies.get("ref")) {
    Cookies.set('ref', ref, { expires: 365, domain: 'hyperping.io' });
  }
}

const ProductsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHoveringDropdown, setIsHoveringDropdown] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setTimeout(() => {
      setIsOpen(false);
    }, 0);
  }, []);

  const handleDropdownMouseEnter = () => {
    setIsHoveringDropdown(true);
  };

  const handleDropdownMouseLeave = () => {
    if (isOpen) return;
    setIsHoveringDropdown(false);
    setIsOpen(false);
  };

  return (
    <div
      style={{ position: 'relative' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        style={{ height: '66px',marginRight:'16px' }}
        className="flex align-items-center header-link mobile gap-035em cursor-pointer color-white"
      >
        Products
        <Icons size="small" name="chevrondown" className={`chevron-icon ${isOpen ? 'rotate' : ''}`} />
      </div>
      {isOpen && (
        <div
          className="products-dropdown"
          onMouseEnter={handleDropdownMouseEnter}
          onMouseLeave={handleDropdownMouseLeave}
        >
          <a href="/uptime-monitoring" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="globe" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">Uptime Monitoring</div>
              <div className="pnl-text">HTTP, ICMP, Port, SSL, text assertion</div>
            </div>
          </a>
          
          <a href="/synthetic-monitoring" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="cpu" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">Browser Checks</div>
              <div className="pnl-text">E2E tests with Playwright</div>
            </div>
          </a>
          
          <a href="/cron-job-monitoring" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="heartbeat" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">Cron Monitoring</div>
              <div className="pnl-text">Cron jobs and other periodic processes</div>
            </div>
          </a>
          
          <a href="/status-page" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="megaphone" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">Status Page</div>
              <div className="pnl-text">Communicate service status and incidents to users</div>
            </div>
          </a>

        </div>
      )}
    </div>
  );
};

const CustomersDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHoveringDropdown, setIsHoveringDropdown] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setTimeout(() => {
      setIsOpen(false);
    }, 0);
  }, []);

  const handleDropdownMouseEnter = () => {
    setIsHoveringDropdown(true);
  };

  const handleDropdownMouseLeave = () => {
    if (isOpen) return;
    setIsHoveringDropdown(false);
    setIsOpen(false);
  };

  return (
    <div
      style={{ position: 'relative' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        style={{ height: '66px', marginRight: '16px' }}
        className="flex align-items-center header-link mobile gap-035em cursor-pointer color-white"
      >
        Customers
        <Icons size="small" name="chevrondown" className={`chevron-icon ${isOpen ? 'rotate' : ''}`} />
      </div>
      {isOpen && (
        <div
          className="products-dropdown"
          onMouseEnter={handleDropdownMouseEnter}
          onMouseLeave={handleDropdownMouseLeave}
        >
          <a href="/customers" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="users" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">Customer Highlights</div>
              <div className="pnl-text">Case studies and testimonials</div>
            </div>
          </a>
          
          <a href="/customers/showcase" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="medal" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">Customer Showcase</div>
              <div className="pnl-text">Featured customer status pages</div>
            </div>
          </a>
        </div>
      )}
    </div>
  );
};

const Header = ({ isBlogPage, isBlogArticle }) => {
  const [isScrollTop, setIsScrollTop] = React.useState(true);
  // const paths = useInternalPaths();
  // console.log(paths);
  
  // Add state for path detection
  // const [isBlogPage, setIsBlogPage] = useState(false);
  // const [isBlogArticle, setIsBlogArticle] = useState(false);
  
  // Effect for scroll detection
  React.useEffect(() => {
    const onScroll = e => {
      setIsScrollTop(e.target.documentElement.scrollTop === 0);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  
  // Separate effect for cookies and path detection
  React.useEffect(() => {
    setCookies();
    
    // Handle path detection
    // const path = window.location.pathname;
    // setIsBlogPage(path === '/blog/' || path === '/blog');
    // setIsBlogArticle(path.startsWith('/blog/') && path !== '/blog/' && path !== '/blog');
  }, []);

  return (
    <div className={`header-sticky-wrapper ${isScrollTop ? 'scroll-top' : ''} ${isBlogPage ? 'in-blog' : ''} ${isBlogArticle ? 'in-blog-article' : ''}`}>
      <header className="header-sticky">
        <nav className="header-nav">
          <div className="flex align-items-center">
            <a href="/" className="header-logo mr-3em">
              <img height="28px" src={logoWhite} />
            </a>
            <ProductsDropdown />
            <CustomersDropdown />
            <a className="header-link mobile" href="/features">Features</a>
            <a className="header-link mobile" href="/docs">Docs</a>
            <a className="header-link mobile" href="/blog">Blog</a>
            <a className="header-link" href="/pricing">Pricing</a>
          </div>
          <div className="flex align-items-center">
            <a className="header-link login-link" target="_blank" href="https://app.hyperping.io/login">Log in</a>
            <a className="header-link signup-link plausible-event-name=Signup+attempt" target="_blank" href="https://app.hyperping.io/register"><Button>Sign up <img src={RightArrow} style={{marginTop:'1px'}} /></Button></a>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Header;
